import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

export const Catalog = ({ onInquire }) => {
  const [gens, setGens] = useState([]);
  useEffect(() => { api.get("/generators").then((r) => setGens(r.data)).catch(() => {}); }, []);
  return (
    <section id="fleet" className="section catalog">
      <div className="sec-head">
        <div>
          <p className="eyebrow">THE FLEET</p>
          <h2 className="sec-title">Machines ready<br /><em>to work.</em></h2>
        </div>
        <a data-testid="catalog-contact-link" className="sec-link" href="#booking">Need help choosing? <ArrowUpRight size={15} /></a>
      </div>
      <div className="bento">
        {gens.map((g, i) => (
          <motion.article key={g.gen_id} data-testid={`generator-card-${g.gen_id}`} className={i === 0 ? "dg-card dg-lead" : "dg-card"}
            initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.1, ease: [0.76, 0, 0.24, 1] }}>
            <div className="dg-media">
              {g.image && <img src={g.image.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${g.image}` : g.image} alt={`${g.name} diesel generator`} loading="lazy" />}
              {g.tag && <span className="dg-tag">{g.tag}</span>}
            </div>
            <div className="dg-body">
              <div className="dg-row">
                <div><h3>{g.name}</h3><p className="dg-desc">{g.description}</p></div>
                <span className="dg-cap">{g.capacity}</span>
              </div>
              <div className="dg-foot">
                <strong>{g.price}</strong>
                <button data-testid={`generator-inquiry-${g.gen_id}`} className="dg-cta" onClick={() => onInquire(g)}>
                  Inquire <ArrowUpRight size={14} />
                </button>
              </div>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
};
